<template>
  <v-app>
    <!-- seitliche Navigationsleiste -->
    <v-navigation-drawer v-model="drawer" :clipped="$vuetify.breakpoint.lgAndUp" app>
      <v-list dense nav>
        <v-list-item v-for="item in items" :key="item.title" :to="item.path" link>
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <!-- Top Navigationsleiste -->
    <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app color="#f7f7f7" light>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />

      <v-toolbar-title>SelTip</v-toolbar-title>

      <v-spacer></v-spacer>

      <locale-changer></locale-changer>

      <v-avatar size="36px" tile class="ml-6">
        <v-img src="/img/icons/TTib_logo.png" alt="ttib"></v-img>
      </v-avatar>
    </v-app-bar>

    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
import { bus } from "./main";
import LocaleChanger from "../src/components/LocaleChanger";

export default {
  name: "App",
  components: {
    LocaleChanger
  },
  created() {
    bus.$on("refreshCountry", () => {
      this.localizeMenu();
    });    
  },
  mounted: function() {
    this.localizeMenu();
  },
  methods: {
    localizeMenu() {
      this.items =  [
        { title: this.$t('tip_calculation'), icon: "mdi-cash",                      path: "/" },
        { title: this.$t('contact'),         icon: "mdi-contact-mail-outline",      path: "/contact" },
        { title: this.$t('imprint'),         icon: "mdi-clipboard-account-outline", path: "/imprint" }
      ];
    },
  },
  data: () => ({
    drawer: false,
    tipCalc: null,
    items: null,
  }),
};
</script>
